import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PicturesBaseService } from './pictures-base.service';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * Property pictures service
 */
@Injectable({
  providedIn: 'root'
})
export class PropertyPicturesService extends PicturesBaseService {
  /**
   * Constructor
   * @param appServiceHelper AppServiceHelperService
   * @param httpClient HttpClient
   */
  constructor(appServiceHelper: AppServiceHelperService, httpClient: HttpClient) {
    super(appServiceHelper, httpClient, 'pollux.projectValuation.api', 'pollux.api', '', 'propertyId');
  }
}
